// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_hs","advertDetailContacts__header":"c-m_ht"};